<template>
  <!-- <el-menu class="navbar" mode="horizontal"> -->
      <div class="navbars">
        <div class="logoimg">
          <a href="http://www.yanzhaobz.com.cn/">
            <img src="../../../assets/images/logo.png" >
          </a>
        </div>
        <!-- <div class="search">
          <el-input placeholder="请输入内容" v-model="searchVal" class="searchinput">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button @click="searchbtn" type="primary" icon="el-icon-search">搜索</el-button>
        </div> -->
        <div class="user" @mouseenter="showben" @mouseleave="hiddbtn">
          <img class="user-avatar" :src="avatar">
          <div><span>{{name}}</span><i class="el-icon-caret-bottom"></i></div>
          <el-card v-show="seen" class="box-card cardhidden" @mouseenter="showben">
                <div class="txt" @click="backhone">首页</div>
                <div class="txt" @click="logout">退出</div>
                <div class="txt" @click="editUserPass">修改密码</div>
          </el-card>
        </div>
      </div>
    <!-- <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger> -->
    <!-- <breadcrumb></breadcrumb> -->
    <!-- <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
        <el-dropdown-item>
          <span size="mini" @click="editUserPass" style="display:block;">修改密码</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
  <!-- </el-menu> -->
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import {getInfo} from '@/api/login'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'

  export default {
    data() {
      return{
        searchVal:'',
        seen:false,
		
      }
    },
    components: {
      Breadcrumb,
      Hamburger
    },
    computed: {
      ...mapGetters([
        // 'sidebar',
        'avatar','name'
      ])
    },
    methods: {
      // 返回首页
      backhone(){
        this.$router.push({
          path: '/home'
        });
      },
      //退出修改密码隐藏
      hiddbtn(){
        this.seen=false;
      },
      //退出修改密码显示
      showben(){
        this.seen=true;
      },
      toggleSideBar() {
        this.$store.dispatch('ToggleSideBar')
      },
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      },
      editUserPass() {
		  let $this=this;
        $this.$router.push({
          path: '/user/editUserPass'
        });
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .navbars{
    height: 92px;
    background-color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .navbars .logoimg{
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 21px;
  }
  .navbars .logoimg a{
    display: inline-block;
  }
  .navbars .logoimg a img{
    width: 376px;
    height: 62px;
  }

  .navbars .search{
    width: 680px;
    display: flex;
    align-items: center;
  }
 /deep/ .el-input__inner{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
/deep/ .el-button{
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.navbars .user{
  position: relative;
  width: 180px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.navbars .user img{
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.navbars .user span{
  font-size: 18px;
  font-weight: 400;
  color: #4A5162;
  margin: 0 12px 0 14px;
}

// .navbars .user .hiddenbtn{
//   display: none;
//   position: absolute;
//   top: 0;
//   left: 0;
//   background-color: #FFFFFF;
// }

.box-card{
  position: absolute;
  top: 80%;
  left: 5%;
  width: 70%;
  height: 150px;
  z-index: 999;
  // display: none;
}
.box-card .txt{
  color: #333333;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  // cursor: pointer;
}
.box-card .txt:hover{
  background-color: #F4F0F0;
}















  .navbar {
    height: 92px;
    // line-height: 130px;
    border-radius: 0px !important;

    .hamburger-container {
      display: none;
      line-height: 140px;
      height: 130px;
      float: left;
      padding: 0 10px;
    }

    .screenfull {
      position: absolute;
      right: 90px;
      top: 16px;
      color: red;
    }

    .avatar-container {
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 35px;

      .avatar-wrapper {
        cursor: pointer;
        margin-top: 10px;
        position: relative;

.user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }

        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 55px;
          font-size: 12px;
        }
      }
    }
  }

  .el-submenu__icon-arrow {
    right: 50px !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue